import { getTimezoneOffset } from 'date-fns-tz';

import { UNKNOWN_TIMEZONE, UNRECOGNIZED, viewerLocalTimeLabel } from '../../configs';
import type { DropdownOption } from '../Dropdown';

export const getTimezoneWithGMT = (timeZone: string): string => {
  // The backend serializes the _UNKNOWN sentinel (and we have nothing for an empty value) for
  // timezones it can't map. These are expected, not bugs, so short-circuit before date-fns-tz to
  // avoid flooding the console/RUM with "timezone is not supported".
  if (!timeZone || timeZone === UNKNOWN_TIMEZONE) {
    return UNRECOGNIZED;
  }

  const timezoneOffset = getTimezoneOffset(timeZone);

  if (isNaN(timezoneOffset)) {
    console.error(`${timeZone} timezone is not supported`);

    return UNRECOGNIZED;
  }
  const timezoneOffsetHours = timezoneOffset / 1000 / 60 / 60;
  const offsetSign = timezoneOffsetHours >= 0 ? '+' : '';

  const timezoneGMT = `(GMT${offsetSign}${timezoneOffsetHours})`;

  return `${timeZone} ${timezoneGMT}`;
};

export const getSelectedTimezone = (
  timezone: string,
  deliveryInViewerTime: boolean,
  optionsWithViewerLocalTime: DropdownOption<string>[]
): DropdownOption<string> => {
  return deliveryInViewerTime
    ? {
        value: timezone,
        label: viewerLocalTimeLabel,
      }
    : optionsWithViewerLocalTime.find((el) => el.label === getTimezoneWithGMT(timezone)) || {
        value: timezone,
        label: getTimezoneWithGMT(timezone),
      };
};
